import { render, staticRenderFns } from "./Fragebogen.vue?vue&type=template&id=11c9b3be&"
import script from "./Fragebogen.vue?vue&type=script&lang=js&"
export * from "./Fragebogen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports